import type { EmptyOrOnlyMeInMembers } from './types'

export const emptyOrOnlyMeInMembers = ({ teamMemberList, personIds }: EmptyOrOnlyMeInMembers) =>
  !teamMemberList.length || (personIds && teamMemberList.length === 1 && personIds.includes(teamMemberList[0].personId))
